const AppColors = {
  // Primary Colors (Aligned with Vendor Panel)
  primaryDark: '#0E2537',
  primaryGray: '#F0F2F5',
  primaryBlue: '#3A7CA5',
  primaryYellow: '#F5880A', // Consistent with vendor panel

  // Secondary Colors
  secondaryBlue: '#3A7CA5',
  secondaryGreen: '#4CAF50',

  // Accent Colors
  accentOrange: '#FFA726',
  accentPurple: '#9C27B0',

  // Background Colors
  backgroundWhite: '#FFFFFF',
  backgroundLightGray: '#F5F5F5',
  backgroundGray: '#E0E0E0',
  backgroundDark: '#121212',
  backgroundDefault: '#FFFFFF',

  // Text Colors
  textPrimary: '#0E2537', // Matches primaryDark
  textSecondary: '#757575',
  textWhite: '#FFFFFF',
  textBlack: '#000000',
  textGray: '#9E9E9E',

  // Error Colors
  errorRed: '#F44336',

  // Success Colors
  successGreen: '#4CAF50',

  // Warning Colors
  warningOrange: '#FF9800',

  // Info Colors
  infoBlue: '#2196F3',

  // Neutral Colors
  neutralLight: '#E0E0E0',
  neutralMedium: '#BDBDBD',
  neutralDark: '#616161',
};

export default AppColors;
